<template>
    <div class="default-group">
        <div class="card-curvey group-card">
                <v-expansion-panel expand :value="0">
                    <v-expansion-panel-content>
                        <template v-slot:header>
                            <v-text-field
                                    class="solo-input handle"
                                    v-model="group.title"
                                    @change="updateGroup"
                                    @click.native.stop="editTitle"
                            ></v-text-field>
                        </template>
                        <draggable @change="draggedToGroup" class="layout row wrap" v-model="blocksList" group="people" @start="drag=true" @end="drag=false" handle=".blockHandeler">
                            <v-flex xs4
                                    v-for="block in blocksList"
                                    class="blockHandeler"
                            >
                                <v-btn
                                        large round block
                                        :color="selectedBlock.id === block.id ? 'primary': '#F4F5F9'"
                                        @click="setSelectedBlock(block)"
                                >
                                    {{block.name}}
                                </v-btn>
                            </v-flex>
                            <v-flex xs4>
                                <v-btn
                                        large round block
                                        @click="addNewBlock(group.id)"
                                        color="white"
                                        class="text-gray"
                                >
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </v-flex>
                        </draggable>
                    </v-expansion-panel-content>
                 </v-expansion-panel>
        </div>
    </div>
</template>

<script>
    import common from "../../../utils/common";
    import draggable from 'vuedraggable'
    export default {
        name: "default-group",
        components: {
            draggable
        },
        props: {
            group: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            blocks: {
                type: Array,
                default: ()=> {
                    return []
                }
            },
            index: {
                Array,
                default: ()=> {
                    return 0
                }
            }
        },
        data() {
            return{
                blocksList: []
            }
        },
        mounted() {
            this.blocksList = this.blocks
        },
        methods: {
            setSelectedBlock(block) {
                this.$store.dispatch('setSelectedBlock',block)
            },
            addNewBlock(group_id) {
                this.$store.dispatch('setSavingStatus', true)
                this.$store.dispatch('setLoader',true)
                this.$http.post('/blocks',{
                    bot_id: this.botId,
                    group_id: group_id,
                    iGroup: -1,
                    name: `Untitled Block ${this.blocks.length+1}`,
                    payload: []
                })
                    .then(response=>{
                        this.blocks.push(response.data)
                        this.$store.dispatch('setSelectedBlock',response.data)
                        this.$store.dispatch('setNewBlock',response.data)
                        this.$store.dispatch('setSavingStatus', false)
                        this.$store.dispatch('setLoader',false)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            draggedToGroup(newItem) {
                if(newItem.added || newItem.moved) {
                    this.updateBlockPosition(newItem.added || newItem.moved)
                }
            },
            async updateBlockPosition(newItem) {
               await this.$store.dispatch('setSavingStatus', true)
                await this.$store.dispatch('setLoader',true)
                let payload = await this.getBlockPayLoad(newItem.element.id)
                this.$http.put(`/blocks/${newItem.element.id}`,  {
                    group_id: this.group.id,
                    name: newItem.element.name,
                    payload: payload.data.payload,
                    order: newItem.newIndex
                })
                    .then(response=>{
                        this.$store.dispatch('setSavingStatus', false)
                        this.$store.dispatch('setLoader',false)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            async getBlockPayLoad(blockId) {
                let response = await this.$http_bot.get(`/blocks/${blockId}`)
                return response
            },
            copyBlock() {
                this.$store.dispatch('setSavingStatus', true)
                this.$store.dispatch('setLoader',true)
                this.$http.post('/blocks',  {
                    bot_id: this.botId,
                    group_id: this.copiedBlock.group_id,
                    iGroup: -1,
                    name: `${this.copiedBlock.name} Copy`,
                    payload: this.copiedBlock.payload
                })
                    .then(response=>{
                        this.blocks.push(response.data)
                        this.$store.dispatch('setSelectedBlock',response.data)
                        this.$store.dispatch('setNewBlock',response.data)
                        this.$store.dispatch('setSavingStatus', false)
                        this.$store.dispatch('setLoader',false)
                    })
                    .catch(error=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            },
            editTitle() {

            },
            updateGroup() {
                this.$store.dispatch('setLoader',true)
                this.$store.dispatch('setSavingStatus', true)
                this.$http.put(`groups/${this.group.id}`,{
                    order: this.index+1,
                    title: this.group.title
                })
                    .then(response=>{
                        this.$store.dispatch('setLoader',false)
                        this.$store.dispatch('setSavingStatus', false)
                    })
                    .catch((error)=>{
                        this.$store.dispatch('setLoader',false)
                        if (error.response && error.response.status === 401) {
                            common.logOut()
                        } else {
                            this.$store.dispatch('setErrorMessage', true)
                        }
                    })
            }
        },
        computed: {
            selectedBlock () {
                return this.$store.state.blocksBuild.selectedBlock
            },
            copiedBlock() {
                return this.$store.state.blocksBuild.copiedBlock
            },
            botId() {
                return this.$store.state.bot.botId
            },
            updatedBlockName() {
                return this.$store.state.blocksBuild.updatedBlockName.name
            }
        },
        watch: {
            group(newVal , oldVal) {
              this.updateGroup()
            },
            blocks () {
                this.blocksList = this.blocks
            },
            copiedBlock(state) {
                if (state.id && state.group_id === this.group.id) {
                    this.copyBlock()
                }
            },
            updatedBlockName(state) {
                const block = this.$store.state.blocksBuild.updatedBlockName
                if (state) {
                    let index = _.findIndex(this.blocks,o=>{
                        return o.id === block.id
                    })
                    if (index !== -1) {
                        this.blocks[index].name = block.name
                    }
                }
            }
        }
    }
</script>

<style scoped>

</style>